import { render, staticRenderFns } from "./ExamGuideView.vue?vue&type=template&id=97da89d8"
import script from "./ExamGuideView.vue?vue&type=script&lang=js"
export * from "./ExamGuideView.vue?vue&type=script&lang=js"
import style0 from "./ExamGuideView.vue?vue&type=style&index=0&id=97da89d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports